// GES frontend entry. Vite bundles this graph for production; the browser
// can also load it directly as native ES modules (no build needed in dev).
//
// Order matters only for top-level side effects. The test harness
// (tests/load-sources.js) reads the two lists below, so keep one import per line.

// core: formerly app.js (plus app/display.js, which must run first)
import "./app/wake.js";
import "./app/pwa.js";
import "./app/display.js";
import "./api.js";
import "./app/shell.js";
import "./ui/charts.js";
import "./views/core/products.js";
import "./ui/help.js";
import "./views/core/briefing.js";
import "./app/onboarding.js";
import "./ui/format.js";
import "./views/core/overview.js";
import "./views/core/financials.js";
import "./views/core/banking.js";
import "./views/core/consulting.js";
import "./views/core/news.js";
import "./views/core/footprint.js";
import "./views/core/markets.js";
import "./views/core/operations.js";
import "./views/core/deals.js";
import "./views/core/ma.js";
import "./views/core/competitors.js";
import "./views/core/risk.js";
import "./views/core/board.js";
import "./views/core/investors.js";
import "./views/core/fx.js";
import "./views/core/macro.js";
import "./views/core/government.js";
import "./views/core/executives.js";
import "./app/commands.js";
import "./ui/modals.js";
// end core

// views and extras: formerly ui.js, ceo.js, auth.js and sections/*.js
import "./ui/kit.js";
import "./views/products.js";
import "./views/banking.js";
import "./views/operations.js";
import "./views/deals.js";
import "./views/launch.js";
import "./views/meetings.js";
import "./views/conversation.js";
import "./views/ranking.js";
import "./views/agenda.js";
import "./views/threads.js";
import "./views/ma.js";
import "./views/government.js";
import "./views/countries.js";
import "./views/holdings.js";
import "./views/ceo.js";
import "./views/nemesis.js";
import "./views/consequences.js";
import "./views/investments.js";
import "./views/offers.js";
import "./views/investhub.js";
import "./views/hub.js";
import "./views/regulators.js";
import "./views/advisor.js";
import "./views/firstyear.js";
import "./app/attention.js";
import "./app/reminders.js";
import "./views/office.js";
import "./views/valuation.js";
import "./views/peopleranking.js";
import "./views/people.js";
import "./views/board.js";
import "./views/investors.js";
import "./views/forge.js";
import "./views/world.js";
import "./views/workforce.js";
import "./views/esg.js";
import "./views/rnd.js";
import "./views/ambassadors.js";
import "./views/marketing.js";
import "./views/takeover.js";
import "./views/moves_growth.js";
import "./views/moves_money.js";
import "./views/moves_people.js";
import "./views/moves_press.js";
// 2026-10-22 round: decisions matter, your rival, contracts, seasons, markets, your life, your dream projects
import "./ui/launchday.js";
import "./ui/glossary.js";
import "./views/round_rival.js";
import "./views/round_growth.js";
import "./views/round_money.js";
import "./app/auth.js";
import "./app/analytics.js";
import "./app/feedback.js";
import "./app/devicetip.js";
import "./app/phonemenu.js";
import "./app/sidebarfoot.js";
// end extras

import "./app/devtools.js";
import { boot } from "./app/shell.js";

boot();

// 2026-10-24: screens nobody needs on day one load the first time they're opened (a smaller first download).
// Each sets its own window.renderX when it loads; the stub hands over to it.
const lazyView = (name, load) => {
  window[name] = async (...args) => {
    const m = await load();
    return m[name](...args);
  };
};
lazyView("renderDream", () => import("./views/dream.js"));
lazyView("renderLifestyle", () => import("./views/lifestyle.js"));
lazyView("renderLeague", () => import("./views/league.js"));
